<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Customers | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="col-lg-10 center center-block" align="center">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                <button
                                    class="btn btn-danger float-right"
                                    @click="add"
                                >
                                    <i class="fa fa-plus"></i> Add Customer
                                </button>
                            </div>
                            <div class="card-body overflow-auto">
                                <div class="col-md-10 float-left">
                                    <div class="row">
                                        <div class="col-sm-4 float-left">
                                            <div class="form-group">
                                                <input
                                                    type="number"
                                                    class="form-control"
                                                    min="5"
                                                    value="10"
                                                    v-model="results"
                                                    placeholder=" Enter No. of results"
                                                    @input="
                                                        getLeads(
                                                            '/api/getWalkins'
                                                        )
                                                    "
                                                />
                                            </div>
                                            <div class="form-group float-left">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="
                                                        getLeads(
                                                            '/api/getWalkins'
                                                        )
                                                    "
                                                >
                                                    <i class="fa fa-search"></i>
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="number"
                                                    placeholder="Enter a number"
                                                />
                                            </div>
                                            <div class="form-group float-left">
                                                <button
                                                    class="btn btn-danger"
                                                    @click="reset"
                                                >
                                                    <i class="fa fa-times"></i>
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group float-left">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    v-model="name"
                                                    placeholder="Enter a name"
                                                />
                                            </div>
                                            <div class="form-group float-left">
                                                <input
                                                    type="date"
                                                    class="form-control"
                                                    v-model="date"
                                                    placeholder="Enter a date"
                                                />
                                            </div>
                                            <div class="form-group">
                                                <span
                                                    class="right badge badge-secondary"
                                                    >Search by Branch:</span
                                                >
                                                <v-select
                                                    v-model="branch"
                                                    class="form-control"
                                                    type="text"
                                                    label="branch"
                                                    :options="branches"
                                                    :reduce="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                    name="branch"
                                                    placeholder="Select Branch"
                                                    :value="
                                                        (branches) =>
                                                            branches.branch_code
                                                    "
                                                ></v-select>
                                            </div>
                                            <div class="form-group float-left">
                                                <select
                                                    v-model="status"
                                                    class="form-control"
                                                    @input="
                                                        getSearchReasons($event)
                                                    "
                                                >
                                                    <option value="Turn-Away">
                                                        Turn Away
                                                    </option>
                                                    <option value="Converted">
                                                        Converted
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="form-group float-left">
                                                <v-select
                                                    v-model="turnaway_reason"
                                                    type="text"
                                                    label="name"
                                                    :options="searchReasons"
                                                    :reduce="
                                                        (searchReasons) =>
                                                            searchReasons.name
                                                    "
                                                    placeholder="Select Reason"
                                                ></v-select>
                                            </div>
                                            <!--<div class="form-group float-left">
      			<button class="btn btn-secondary" @click="excel"><i class="fa fa-print"></i> Generate Excel</button>
      		</div>-->
                                        </div>
                                    </div>
                                </div>
                                <img v-if="leads == ''" src="" />
                                <datatable
                                    style="margin-top: 1%"
                                    :columns="columns"
                                    v-else
                                >
                                    <tbody>
                                        <tr
                                            v-for="lead in leads"
                                            :key="lead.id"
                                        >
                                            <td>{{ lead.name }}</td>
                                            <td>{{ lead.mobile }}</td>
                                            <td>{{ lead.email }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-danger"
                                                    @click="view(lead)"
                                                >
                                                    <i class="fa fa-eye"></i>
                                                    View/Edit
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </datatable>
                                <!-- content here -->
                            </div>
                            <div class="card-footer">
                                <pagination
                                    :pagination="pagination"
                                    @prev="getLeads(pagination.prevPageUrl)"
                                    @next="getLeads(pagination.nextPageUrl)"
                                ></pagination>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->
            <div class="modal" tabindex="-1" role="dialog" id="viewModal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ heading }} Details</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="updateCustomer">
                                <div
                                    :class="[
                                        'form-group',
                                        errors.name ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the customer name"
                                        v-model="form.name"
                                    />
                                    <span
                                        v-if="errors.name"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid name.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.branch ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Branch</label>
                                    <v-select
                                        v-model="form.branch"
                                        class="form-control"
                                        type="text"
                                        label="branch"
                                        :options="branches"
                                        :reduce="
                                            (branches) => branches.branch_code
                                        "
                                        name="branch"
                                        placeholder="Select Branch"
                                        :value="
                                            (branches) => branches.branch_code
                                        "
                                    ></v-select>
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.gender ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Gender</label>
                                    <select
                                        class="form-control"
                                        placeholder="Select customer gender"
                                        v-model="form.gender"
                                    >
                                        <option value="M">Male</option>
                                        <option value="F">Female</option>
                                    </select>
                                    <span
                                        v-if="errors.gender"
                                        :class="['badge bg-danger']"
                                        >Please choose a valid gender.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.mobile ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone 1</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter phone 1"
                                        v-model="form.mobile"
                                    />
                                    <span
                                        v-if="errors.mobile"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid phone
                                        number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.alt_mobile ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone 2</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter phone 2"
                                        v-model="form.alt_mobile"
                                    />
                                    <span
                                        v-if="errors.alt_mobile"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid phone
                                        number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.phone ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone 3</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter phone 3"
                                        v-model="form.phone"
                                    />
                                    <span
                                        v-if="errors.phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid phone
                                        number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.alt_phone ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Phone 4</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter phone 4"
                                        v-model="form.alt_phone"
                                    />
                                    <span
                                        v-if="errors.alt_phone"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid phone
                                        number.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.email ? 'has-error' : '',
                                    ]"
                                >
                                    <label>E-mail</label>
                                    <input
                                        type="email"
                                        class="form-control"
                                        placeholder="Enter email address"
                                        v-model="form.email"
                                    />
                                    <span
                                        v-if="errors.email"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid email.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.alt_email ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Alt E-mail</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter alternate email address"
                                        v-model="form.alt_email"
                                    />
                                    <span
                                        v-if="errors.alt_email"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid email.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.dob ? 'has-error' : '',
                                    ]"
                                >
                                    <label>DOB</label>
                                    <input
                                        type="date"
                                        class="form-control"
                                        placeholder="Enter date of birth"
                                        v-model="form.dob"
                                    />
                                    <span
                                        v-if="errors.dob"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid dob.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.membership_id ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Membership ID</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter membership ID"
                                        v-model="form.membership_id"
                                    />
                                    <span
                                        v-if="errors.membership_id"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid membership
                                        ID.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.category ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Category</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the category"
                                        v-model="form.category"
                                    />
                                    <span
                                        v-if="errors.category"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid category.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.area ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Area</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the area"
                                        v-model="form.area"
                                    />
                                    <span
                                        v-if="errors.area"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid area.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.area ? 'has-error' : '',
                                    ]"
                                >
                                    <label>Status</label>
                                    <select
                                        v-model="form.status"
                                        class="form-control"
                                        @input="getReasons($event)"
                                    >
                                        <option value="Turn-Away">
                                            Turn Away
                                        </option>
                                        <option value="Converted">
                                            Converted
                                        </option>
                                    </select>
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.turnaway_reason
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Turnaway Reason: </label>
                                    <v-select
                                        v-model="form.turnaway_reason"
                                        type="text"
                                        label="name"
                                        :options="reasons"
                                        :reduce="(reasons) => reasons.name"
                                        placeholder="Select Reason"
                                        id="dis1"
                                    ></v-select>
                                    <span
                                        v-if="errors.turnaway_reason"
                                        :class="['badge bg-danger']"
                                        >Please choose a reason.</span
                                    >
                                </div>
                                <div
                                    :class="[
                                        'form-group',
                                        errors.turnaway_description
                                            ? 'has-error'
                                            : '',
                                    ]"
                                >
                                    <label>Turnaway Description</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Enter the description"
                                        v-model="form.turnaway_description"
                                        disabled
                                        id="dis2"
                                    />
                                    <span
                                        v-if="errors.turnaway_description"
                                        :class="['badge bg-danger']"
                                        >Please enter a valid description.</span
                                    >
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-danger"
                                        type="submit"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button
                                class="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
import Datatable from "../../datatable.vue";
import Pagination from "../../pagination.vue";
import { saveAs } from "file-saver";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { datatable: Datatable, pagination: Pagination },

    created() {
        this.getLeads();
        this.getBranches();
    },

    data() {
        let columns = [
            { width: "25%", label: "Name", name: "name" },
            { width: "25%", label: "Mobile", name: "mobile" },
            { width: "25%", label: "E-mail", name: "email" },
            { width: "25%", label: "View More", name: "ops" },
        ];

        return {
            columns: columns,
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
            leads: [],
            results: "",
            name: "",
            number: "",
            heading: "",
            errors: [],
            date: "",
            form: new Form({
                name: "",
                uid: "",
                gender: "",
                mobile: "",
                alt_mobile: "",
                phone: "",
                alt_phone: "",
                email: "",
                alt_email: "",
                dob: "",
                membership_id: "",
                category: "",
                area: "",
                doa: "",
                id: "",
                status: "",
                turnaway_reason: "",
                turnaway_description: "",
                branch: "",
            }),
            reasons: [],
            branches: [],
            branch: "",
            searchReasons: [],
            turnaway_reason: "",
            status: "",
        };
    },

    methods: {
        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        getLeads(url = "/api/getWalkins") {
            axios
                .post(url, {
                    results: this.results,
                    name: this.name,
                    number: this.number,
                    branch: this.branch,
                    from_date: this.from_date,
                    to_date: this.to_date,
                    status: this.status,
                    tar: this.turnaway_reason,
                })
                .then((response) => {
                    this.leads = response.data.data.data;
                    this.configPagination(response.data.data);
                });
        },

        getReasons(e) {
            if (e.target.value == "Turn-Away") {
                axios.post("/api/getAllTAR").then((response) => {
                    this.reasons = response.data;
                    $("#dis1").disabled = false;
                    document.getElementById("dis2").disabled = false;
                });
            } else {
                this.reasons = [];
                this.form.turnaway_reason = "";
                this.form.turnaway_description = "";
                document.getElementById("dis2").disabled = true;
            }
        },

        getSearchReasons(e) {
            if (e.target.value == "Turn-Away") {
                axios.post("/api/getAllTAR").then((response) => {
                    this.searchReasons = response.data;
                });
            } else {
                this.turnaway_reason = "";
                this.searchReasons = [];
            }
        },

        view(lead) {
            this.heading = "Edit";
            this.form.fill(lead);
            $("#viewModal").modal("show");
        },

        add() {
            this.heading = "Add";
            this.form.reset();
            $("#viewModal").modal("show");
        },

        updateCustomer() {
            this.form
                .post("/api/updateWalkin")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Customer Details Updated",
                        });
                        this.getLeads();
                        this.errors = [];
                        $("#viewModal").modal("hide");
                        //document.getElementById("dis1").disabled = true;
                        document.getElementById("dis2").disabled = true;
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Operation Failed",
                        });
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Operation Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        /*excel(){
        		axios({
        		url: "/api/leadsExcel",
        		data: {date: this.date},
        		method: 'post',
        		responseType: 'blob'
        		})
        		.then(response => {
        			toast.fire({
        				icon: 'success',
        				title: 'Report Generated'
        			})
        			var blob = new Blob ([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        			if(this.date != '')
        				saveAs(response.data, this.date+"_leads.xlsx");
        			else
        				saveAs(response.data, "leads.xlsx");
        		})
        	},*/

        reset() {
            this.results = "";
            this.name = "";
            this.number = "";
            this.branch = "";
            this.status = "";
            this.turnaway_reason = "";
            this.getLeads();
        },
    },
};
</script>
